import { getTermsValue, resetTerms, setTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';
import { EEntranceType } from '../../../../api-models/common/json_query';

const ID = 'inputType' as const;

const INPUT_TYPE_MAP_VALUE_TO_LABEL: Record<EEntranceType, string> = {
  [EEntranceType.SeparateCourtyard]: 'Вход со двора',
  [EEntranceType.SeparateStreet]: 'Вход с улицы',
  [EEntranceType.CommonCourtyard]: 'Общий вход со двора',
  [EEntranceType.CommonStreet]: 'Общий вход с улицы',
};

export const inputTypeTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const types = getTermsValue('input_type')(jsonQuery);

    if (types === null) {
      return null;
    }

    return types.map(t => ({
      label: INPUT_TYPE_MAP_VALUE_TO_LABEL[t],
      value: createTagValue(ID, t.toString()),
    }));
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const types = getTermsValue('input_type')(jsonQuery);

    if (types === null) {
      return jsonQuery;
    }

    const next = types.filter(t => String(t) !== removingTagValue);

    return next.length > 0 ? setTerms('input_type')(jsonQuery)(next) : resetTerms(['input_type'])(jsonQuery);
  },
};
